import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Category, Results} from '../../classes/app.models';
import {ApiService} from '../../services/api.service';
import {ModalService} from '../../services/modal.service';

@Component({
    selector: 'app-products-carousel',
    templateUrl: './products-carousel.component.html',
    styleUrls: ['./products-carousel.component.scss']
})
export class ProductsCarouselComponent implements OnInit {
    @Input('results') results: Array<any> = [];
    @Input('listingType') listingType = '';
    // @Input('products') products: Array<Product> = [];
    public categories: Category[];
    public isHovering: string = '0';

    constructor(public apiService: ApiService, public modalService: ModalService, private router: Router) {
    }


    ngOnInit() {

    }

    hoverVideo(index) {
        this.isHovering = this.results[index].id + '';
        this.results[index].isHover = true;
    }


    // hover(id) {
    //     this.isHovering = id;
    // }

}
